module.exports = __webpack_public_path__ + "media/images/icons/country_flags/tn-b66f06d623ea128cc2d69f376311adef.svg";